import Slider from "../components/Slidbar/Slidbar";
import Table from "../components/Courses/Table";

export const Courses = () => {
  return (
    <>
      <Slider />
      <Table />
    </>
  );
};

export default Courses; 